"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BcDataTableToTalValueBehavior = void 0;
var common_constants_1 = require("../../../common/constants/common-constants");
var bc_data_table_constants_1 = require("./bc-data-table-constants");
var BcDataTableToTalValueBehavior = (function () {
    function BcDataTableToTalValueBehavior(bcDataTableConfig) {
        this.bcDataTableConfig = bcDataTableConfig;
        this.dataTableConfig = this.bcDataTableConfig;
    }
    BcDataTableToTalValueBehavior.prototype.setTotalValue = function (dataTable) {
        var headerDiv = this._setTotalValueHtmlStructure();
        dataTable.after(headerDiv);
    };
    BcDataTableToTalValueBehavior.prototype._setTotalValueHtmlStructure = function () {
        var totalValueDiv = this._createTotalValueDiv();
        var tableTotalValue = this._createTableTotalValue();
        totalValueDiv.appendChild(tableTotalValue);
        return totalValueDiv;
    };
    BcDataTableToTalValueBehavior.prototype._createTotalValueDiv = function () {
        var headerDiv = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        headerDiv.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_CONTAINER);
        return headerDiv;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValue = function () {
        var tableTotalValue = document.createElement(common_constants_1.BcCommonConstants.TABLE_TAG);
        tableTotalValue.setAttribute('id', 'data-table-total-value-id');
        tableTotalValue.appendChild(this._createTableTotalValueTr());
        return tableTotalValue;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueTr = function () {
        var _this = this;
        var tableTotalValueTr = document.createElement(common_constants_1.BcCommonConstants.TR_TAG);
        tableTotalValueTr.classList.add('bc-total-value-container');
        this.dataTableConfig.totalValue.cellComplementary &&
            tableTotalValueTr.appendChild(this._createTableTotalValueTd(this.dataTableConfig.totalValue.cellComplementary, true));
        this.dataTableConfig.totalValue.gap &&
            tableTotalValueTr.classList.add("bc-total-value-gap-".concat(this.dataTableConfig.totalValue.gap));
        this.dataTableConfig.totalValue.cells.forEach(function (cell) {
            tableTotalValueTr.appendChild(_this._createTableTotalValueTd(cell));
        });
        return tableTotalValueTr;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueTd = function (cell, isComplementary) {
        var tableTotalValueTd = document.createElement(common_constants_1.BcCommonConstants.TD_TAG);
        tableTotalValueTd.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE);
        isComplementary
            ? tableTotalValueTd.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_CELL_COMPLEMENTARY)
            : tableTotalValueTd.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_CELL_INFORMATION);
        cell.isPrimary &&
            tableTotalValueTd.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_CELL_INFORMATION_PRIMARY);
        cell.width && tableTotalValueTd.classList.add("bc-total-value-".concat(cell.width, "-col-width"));
        tableTotalValueTd.appendChild(this._createTableTotalValueTdLabel(cell.label, isComplementary));
        tableTotalValueTd.appendChild(this._createTableTotalValueTdValue(cell, isComplementary));
        return tableTotalValueTd;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueTdLabel = function (cell, isComplementary) {
        var tableTotalValueDivLabel = document.createElement(common_constants_1.BcCommonConstants.DIV_TAG);
        isComplementary
            ? tableTotalValueDivLabel.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_COMPLEMENTARY_LABEL)
            : tableTotalValueDivLabel.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_INFORMATION_LABEL);
        tableTotalValueDivLabel.appendChild(this._createTableTotalValueTdLabelSpan(cell, isComplementary));
        cell.icon && tableTotalValueDivLabel.appendChild(this._createTableTotalValueTdLabelIcon(cell.icon));
        return tableTotalValueDivLabel;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueTdLabelIcon = function (icon) {
        var tableTotalValueDivLabelIcon = document.createElement(common_constants_1.BcCommonConstants.EM_TAG);
        tableTotalValueDivLabelIcon.classList.add('bc-icon', 'bc-sm');
        icon.tooltip && this._createTableTotalValueTdLabelTooltip(tableTotalValueDivLabelIcon, icon.tooltip);
        tableTotalValueDivLabelIcon.innerHTML = icon.name;
        return tableTotalValueDivLabelIcon;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueTdLabelTooltip = function (icon, tooltip) {
        icon.setAttribute('bctooltiptext', tooltip);
        icon.setAttribute('bctooltipposition', 'top');
        icon.classList.add('bc-tooltip');
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueTdLabelSpan = function (cell, isComplementary) {
        var tableTotalValueDivLabelSpan = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        isComplementary
            ? tableTotalValueDivLabelSpan.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_COMPLEMENTARY_LABEL_FONT)
            : tableTotalValueDivLabelSpan.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_INFORMATION_LABEL_FONT);
        cell.isElipsis && tableTotalValueDivLabelSpan.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_ELLIPSIS);
        cell.extraClass && this._createExtraClass(tableTotalValueDivLabelSpan, cell.extraClass);
        tableTotalValueDivLabelSpan.innerHTML = cell.value;
        return tableTotalValueDivLabelSpan;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueTdValue = function (cell, isComplementary) {
        var tableTotalValuePValue = document.createElement(common_constants_1.BcCommonConstants.P_TAG);
        isComplementary
            ? tableTotalValuePValue.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_COMPLEMENTARY_DATA)
            : tableTotalValuePValue.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_INFORMATION_DATA, bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_INFORMATION_DATA_FONT);
        tableTotalValuePValue.innerHTML = cell.value;
        cell.decimal &&
            !isComplementary &&
            tableTotalValuePValue.appendChild(this._createTableTotalValueDecimal(cell.decimal));
        cell.extraClass && this._createExtraClass(tableTotalValuePValue, cell.extraClass);
        return tableTotalValuePValue;
    };
    BcDataTableToTalValueBehavior.prototype._createTableTotalValueDecimal = function (decimal) {
        var tableTotalValueDivValueDecimal = document.createElement(common_constants_1.BcCommonConstants.SPAN_TAG);
        tableTotalValueDivValueDecimal.classList.add(bc_data_table_constants_1.BcDataTableConstansts.DATA_TABLE_TOTAL_VALUE_INFORMATION_DATA_DECIMAL);
        tableTotalValueDivValueDecimal.innerHTML = decimal;
        return tableTotalValueDivValueDecimal;
    };
    BcDataTableToTalValueBehavior.prototype._createExtraClass = function (element, classes) {
        classes.forEach(function (classElement) {
            element.classList.add(classElement);
        });
    };
    return BcDataTableToTalValueBehavior;
}());
exports.BcDataTableToTalValueBehavior = BcDataTableToTalValueBehavior;
